"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.menuButtonTheme = exports.iconButtonPosition = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

({}); // @related-file ./menuButton.css

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var classNames = require('classnames');

var menuButtonTheme = Object.freeze({
  normal: 'bg-transparent menu-button menu-button-color',
  active: 'bg-theme-main-blue menu-button text-white'
});
exports.menuButtonTheme = menuButtonTheme;
var iconButtonPosition = Object.freeze({
  left: 'justify-start gap-2',
  center: 'justify-center gap-2'
}); // iconPosition prop must be "left or center"
// icon prop must have "url" of icon or "path" of icon

exports.iconButtonPosition = iconButtonPosition;

function MenuButton(props) {
  var _classNames;

  var label = props.label,
      normal = props.normal,
      width = props.width,
      minWidth = props.minWidth,
      height = props.height,
      icon = props.icon,
      iconPosition = props.iconPosition,
      disabled = props.disabled,
      _onClick = props.onClick,
      href = props.href,
      relativeImgPath = props.relativeImgPath,
      extraClasses = props.extraClasses;

  var _useState = (0, _react.useState)(''),
      iconColorChange = _useState[0],
      setIconColorChange = _useState[1];

  (0, _react.useEffect)(function () {
    if (!normal) {
      setIconColorChange('-white');
    }
  }, []);

  var hoverFunc = function hoverFunc() {
    if (normal) {
      setIconColorChange('-white');
    }
  };

  var hoverLeaveFunc = function hoverLeaveFunc() {
    if (normal) {
      setIconColorChange('');
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-full flex",
    style: {
      height: height,
      width: width,
      minWidth: minWidth
    }
  }, /*#__PURE__*/_react.default.createElement("button", {
    style: {
      width: '100%',
      height: '100%'
    },
    type: "button",
    className: classNames('flex justify-start items-center gap-2.5 font-normal px-5 hover:bg-theme-main-blue hover:text-white', (_classNames = {}, _classNames[menuButtonTheme.normal] = normal === true && disabled === false, _classNames[menuButtonTheme.active] = normal === false && disabled === false, _classNames[iconButtonPosition.left] = iconPosition.length > 0 && icon.length > 0 && iconPosition === 'left', _classNames[menuButtonTheme.disabled] = disabled === true, _classNames[extraClasses] = extraClasses !== '', _classNames)),
    disabled: disabled,
    onClick: function onClick() {
      return _onClick(href);
    },
    onMouseEnter: hoverFunc,
    onMouseLeave: hoverLeaveFunc
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "w-6 flex justify-center items-center"
  }, icon.length > 0 && /*#__PURE__*/_react.default.createElement("img", {
    src: "" + relativeImgPath + icon + iconColorChange + ".svg",
    alt: icon
  })), label.length > 0 && /*#__PURE__*/_react.default.createElement("span", null, label), icon && /*#__PURE__*/_react.default.createElement("span", null)));
}

var _default = MenuButton;
exports.default = _default;
MenuButton.propTypes = {
  normal: _propTypes.default.bool.isRequired,
  label: _propTypes.default.string.isRequired,
  href: _propTypes.default.string.isRequired,
  relativeImgPath: _propTypes.default.string.isRequired,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onClick: _propTypes.default.func,
  icon: _propTypes.default.string,
  minWidth: _propTypes.default.string,
  iconPosition: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  extraClasses: _propTypes.default.string
};
MenuButton.defaultProps = {
  onClick: undefined,
  icon: '',
  iconPosition: iconButtonPosition.left,
  disabled: false,
  minWidth: '30px',
  extraClasses: ''
};